import React, { useMemo, useState } from 'react';
import Footer from '../components/footer';
import '../styles/birthday.modules.css';
import { useSchedule } from '../data/useLocations';
import Seo from '../components/Seo';

const SR_ONLY = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

const selectStyle = {
  outline: "none",
  fontWeight: "bold",
  backgroundColor: "#d0142d",
  border: "1px solid rgb(0,0,0,0)",
  color: "rgb(250,250,250)",
  fontSize: "17px",
  borderRadius: "6px",
  height: "50px",
  padding: "0px 20px",
  marginTop: "-10px",
  marginBottom: "20px",
};

const noteRowStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
};

const noteTextStyle = {
  fontWeight: "bold",
  fontSize: "14px",
  color: "rgb(30,30,30)",
  marginTop: "10px",
};

/** Buduje zdanie o poczęstunku dla rodziców z danych lokalizacji. */
function parentsNote(loc, packages) {
  if (!loc || loc.parentsPrice == null) return null;

  const included = packages.filter((p) => (loc.parentsIncludedIn || []).includes(p.id));
  const toBuy = packages.filter(
    (p) => !(loc.parentsIncludedIn || []).includes(p.id) && loc.prices?.[p.id] != null
  );

  const label = (list) => list.map((p) => p.name.replace(/^PAKIET\s+/i, "")).join(", ");

  if (toBuy.length === 0 && included.length === 0) return null;

  if (toBuy.length === 0) {
    return `Do pakietów ${label(included)} poczęstunek dla rodziców na osobnej sali/poczekalni wchodzi w cenę.`;
  }

  if (included.length === 0) {
    return `Do pakietów ${label(toBuy)} istnieje możliwość dokupienia poczęstunku dla rodziców na osobnej sali/poczekalni w cenie ${loc.parentsPrice} zł.`;
  }

  return `Do pakietów ${label(toBuy)} istnieje możliwość dokupienia poczęstunku dla rodziców na osobnej sali/poczekalni w cenie ${loc.parentsPrice} zł, do pakietu ${label(included)} opcja ta wchodzi w cenę.`;
}

function Birthday() {
  const { data, loading } = useSchedule();

  const birthday = data?.birthday || null;
  const [locationId, setLocationId] = useState("");

  const packages = birthday?.packages || [];
  const locations = birthday?.locations || [];

  const selected = useMemo(
    () => locations.find((l) => l.id === locationId) || null,
    [locations, locationId]
  );

  /** Pakiety dostępne w wybranej lokalizacji, z podstawioną liczbą gości. */
  const visiblePackages = useMemo(() => {
    if (!selected) return [];

    return packages
      .filter((p) => selected.prices?.[p.id] != null)
      .map((p) => ({
        ...p,
        price: selected.prices[p.id],
        features: (p.features || []).map((f) => ({
          ...f,
          text: String(f.text || "").replaceAll("{guests}", selected.guests),
        })),
      }));
  }, [packages, selected]);

  const extraNote = useMemo(
    () => parentsNote(selected, packages),
    [selected, packages]
  );

  const locationSelect = (
    <select
      value={locationId}
      onChange={(e) => setLocationId(e.target.value)}
      style={selectStyle}
      aria-label="Wybierz lokalizację"
    >
      <option value="">Wybierz lokalizację</option>
      {locations.map((l) => (
        <option key={l.id} value={l.id}>
          {l.label}
        </option>
      ))}
    </select>
  );

  return (
    <main style={({position: "relative", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center", gap: "35px", width: "100%"})}>
      <Seo
        title="Urodziny dla dzieci"
        description="Urodziny w powietrzu - akrobatyka na hamakach i kołach, animacje i zabawa pod okiem instruktorek. Wrocław i Jastrzębie-Zdrój, Mszana i okolice."
        path="/urodziny"
      />

      <h1 style={SR_ONLY}>Urodziny dla dzieci w 4STARS - pakiety i cennik</h1>

      <div className='content' style={({position: "relative", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center", gap: "35px", width: "100%"})}>

        {!loading && locations.length === 0 ? (
          <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "140px", minHeight: "40vh", maxWidth: "700px", width: "90%", textAlign: "center", gap: "12px"})}>
            <h2 style={({fontWeight: "bold", fontSize: "19px"})}>Ofertę urodzinową przygotowujemy</h2>
            <p style={({fontSize: "14px", color: "rgba(0,0,0,0.65)"})}>
              Zadzwoń pod numer 505 376 552 albo napisz - przedstawimy aktualne pakiety i terminy.
            </p>
          </div>
        ) : null}

        {!selected && locations.length > 0 ? (
          <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "140px", maxWidth: "100%", gap: "30px"})}>
            <h2 style={({fontWeight: "bold", fontSize: "19px", textAlign: "center", width: "90%"})}>
              Wybierz lokalizację, aby poznać ofertę urodzin!
            </h2>
            {locationSelect}
          </div>
        ) : null}

        {selected ? (
          <section style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "140px", maxWidth: "100%", gap: "30px", width: "100%"})}>
            <h2 style={({fontWeight: "bold", fontSize: "19px", textAlign: "center"})}>Poznaj ofertę urodzin!</h2>
            {locationSelect}

            <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"})}>
              <h3 style={({fontWeight: "bold", fontSize: "20px", textAlign: "center"})}>Pakiety urodzinowe</h3>
              <h3 style={({fontSize: "14px", textAlign: "center"})}>Wybierz pakiet, który najbardziej Ci odpowiada!</h3>
            </div>

            <div className='birthDaySection' style={({display: "flex"})}>
              {visiblePackages.map((p) => (
                <div key={p.id} className='birthDaySection_panel' style={({display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center", border: "2px solid rgb(30,30,30, 0.2)", borderRadius: "6px"})}>
                  <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "60px", backgroundColor: "#d0142d"})}>
                    <h3 style={({fontWeight: "bold", fontSize: "19px", color: "rgb(250,250,250)", marginTop: "10px"})}>{p.name}</h3>
                  </div>

                  <div style={({display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", width: "90%", marginTop: "10px"})}>
                    {p.features.map((f, idx) => (
                      <div key={idx} style={noteRowStyle}>
                        <img
                          src={f.included ? "/done.png" : "/x.png"}
                          alt=""
                          style={({width: "35px", height: "35px", marginTop: "5px"})}
                        />
                        <h4 style={noteTextStyle}>{f.text}</h4>
                      </div>
                    ))}
                  </div>

                  <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "60px", backgroundColor: "#d0142d", marginTop: "20px"})}>
                    <h3 style={({fontWeight: "bold", fontSize: "19px", color: "rgb(250,250,250)", marginTop: "10px"})}>CENA: {p.price} ZŁ</h3>
                  </div>
                </div>
              ))}
            </div>

            <div style={({display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", width: "80%", gap: "15px"})}>
              {(birthday.notes || []).map((n) => (
                <div key={n.id} style={noteRowStyle}>
                  <img src="/done.png" alt="" style={({width: "35px", height: "35px", marginTop: "5px"})} />
                  <h4 style={noteTextStyle}>{n.text}</h4>
                </div>
              ))}

              {extraNote ? (
                <div style={noteRowStyle}>
                  <img src="/done.png" alt="" style={({width: "35px", height: "35px", marginTop: "5px"})} />
                  <h4 style={noteTextStyle}>{extraNote}</h4>
                </div>
              ) : null}

              {(birthday.footnotes || []).map((f, idx) => (
                <h4
                  key={f.id}
                  style={({fontSize: "11px", fontWeight: "normal", color: "rgb(30,30,30)", marginTop: idx === 0 ? "20px" : "-15px"})}
                >
                  * {renderFootnote(f.text, birthday.termsUrl)}
                </h4>
              ))}
            </div>

            {birthday.customOffer ? (
              <section className="birthDayIndividual" style={({display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", backgroundColor: "#d0142d", gap: "5px"})}>
                <h3 style={({color: "rgb(250,250,250)", fontWeight: "bold", marginBottom: "10px"})}>
                  {birthday.customOffer.title}
                </h3>
                <span style={({color: "rgb(250,250,250)", fontWeight: "normal"})}>
                  {birthday.customOffer.text}
                </span>
              </section>
            ) : null}
          </section>
        ) : null}
      </div>

      <Footer />
    </main>
  );
}

/** Zamienia słowo REGULAMINEM na odnośnik do PDF, gdy termsUrl jest ustawione. */
function renderFootnote(text, termsUrl) {
  const word = "REGULAMINEM";

  if (!termsUrl || !text.includes(word)) return text;

  const [before, after] = text.split(word);

  return (
    <>
      {before}
      <a
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#d0142d", fontWeight: "bold" }}
      >
        {word}
      </a>
      {after}
    </>
  );
}

export default Birthday;